import { render, staticRenderFns } from "./DealModalForm.vue?vue&type=template&id=47506ea6&scoped=true"
import script from "./DealModalForm.vue?vue&type=script&lang=js"
export * from "./DealModalForm.vue?vue&type=script&lang=js"
import style0 from "./DealModalForm.vue?vue&type=style&index=0&id=47506ea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47506ea6",
  null
  
)

export default component.exports